import axios from 'axios';

// מידע סטטי של נקודות גלישה
const mockSpots = [
  {
    _id: "1",
    name: "חוף בת גלים",
    lat: 32.83568091163115,
    lon: 34.979107445918224,
    reviews: [
      { review: "מקום מעולה עם גלים עקביים." },
      { review: "מושלם לכל רמות הגלישה." },
    ],
  },
  {
    _id: "2",
    name: "חוף הכרמל",
    lat: 32.80706609419289,
    lon: 34.955085153046845,
    reviews: [
      { review: "גלים נעימים ומקום פחות עמוס." },
      { review: "מקום טוב למתחילים." },
    ],
  },
  {
    _id: "3",
    name: "חוף הדולפינריום",
    lat: 32.056160217433934,
    lon: 34.75481495629917,
    reviews: [
      { review: "גלים עקביים ותשתיות טובות." },
      { review: "מושלם לגלישה בערב." },
    ],
  },
  {
    _id: "4",
    name: "המערבי",
    lat: 32.07020680680387,
    lon: 34.76325322319874,
    reviews: [
      { review: "גלים מעולים וטיילת נעימה." },
      { review: "יכול להיות עמוס בזמנים שיא." },
    ],
  },
  {
    _id: "5",
    name: "אשדוד",
    lat: 31.812361822518415,
    lon: 34.6374960410543,
    reviews: [
      { review: "גלים טובים ופחות עמוס." },
      { review: "חוף נחמד עם הרבה מקום." },
    ],
  },
  {
    _id: "6",
    name: "חוף זיקים",
    lat: 31.612761975851395,
    lon: 34.50454322572717,
    reviews: [
      { review: "מצוין לגולשי לונגבורד." },
      { review: "חוף יפה ונקי." },
    ],
  },
  {
    _id: "7",
    name: "חוף גורדון",
    lat: 32.08279484235601,
    lon: 34.76713452251632,
    reviews: [
      { review: "מקום פופולרי עם גלים עקביים." },
      { review: "עמוס אך שווה את הגלישה." },
    ],
  },
  {
    _id: "8",
    name: "חוף דדו",
    lat: 32.794245386658034,
    lon: 34.95513631126248,
    reviews: [
      { review: "גלים נעימים וטובים לכל הרמות." },
      { review: "מקום נהדר ליום כיף." },
    ],
  },
  {
    _id: "9",
    name: "חוף מכמורת",
    lat: 32.40729013259492,
    lon: 34.8675468879898,
    reviews: [
      { review: "פחות עמוס וגלים נחמדים." },
      { review: "מושלם לגלישה שקטה." },
    ],
  },
  {
    _id: "10",
    name: "חוף בת ים",
    lat: 32.01110270814183,
    lon: 34.735896325763164,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "11",
    name: "חוף פולג",
    lat: 32.27323363978538,
    lon: 34.833148817102845,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "12",
    name: "חוף אשקלון",
    lat: 31.672596207587148,
    lon: 34.55035965500123,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "13",
    name: "חוף גוטה",
    lat: 31.69263403735732,
    lon: 34.56597377452226,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "14",
    name: "נקודת השועלים",
    lat: 31.700078133396804,
    lon: 34.5707745470918,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "15",
    name: 'חוף י"א',
    lat: 31.786822539730952,
    lon: 34.62548076987373,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "16",
    name: "חוף הקשתות",
    lat: 31.80060941592808,
    lon: 34.63267159034789,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "17",
    name: "חוף ראשון לציון ",
    lat: 31.99985450327833,
    lon: 34.73171894241698,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "18",
    name: "חוף הגולשים - בת ים",
    lat: 32.029763664509396,
    lon: 34.740996533058734,
    reviews: [
      { review: "מקום יפה עם גלים מעולים." },
      { review: "מקום טוב לגולשים מנוסים יותר." },
    ],
  },
  {
    _id: "19",
    name: "חוף פלמחים",
    lat: 31.92637146426101,
    lon: 34.69634620276138,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "20",
    name: "מאנטה ריי",
    lat: 32.06224472657424,
    lon: 34.75957142296405,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "21",
    name: "חוף הילטון",
    lat: 32.08934240451384,
    lon: 34.76715410710143,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "22",
    name: "חוף טופסי",
    lat: 32.09223700266134,
    lon: 34.768657347376376,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "23",
    name: "חוף תל ברוך",
    lat: 32.122439556361115,
    lon: 34.78281354149086,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "24",
    name: "חוף הצוק",
    lat: 32.14220873254746,
    lon: 34.78926017167096,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "25",
    name: "הדרומי - חוף הכוכבים",
    lat: 32.15715977815639,
    lon: 34.793391591526856,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "26",
    name: "חוף המרינה - ארנה פוינט",
    lat: 32.1659932268429,
    lon: 34.79458618245599,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "27",
    name: "חוף אכדיה",
    lat: 32.170535568316794,
    lon: 34.79702724776341,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "28",
    name: "חוף זבולון",
    lat: 32.17509168103898,
    lon: 34.80021056250177,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "29",
    name: "חוף גזיבו",
    lat: 32.17827402920147,
    lon: 34.80151716710613,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "30",
    name: "חוף סידני עלי",
    lat: 32.188394121863276,
    lon: 34.80382886372041,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "31",
    name: "חוף געש",
    lat: 32.22857685783908,
    lon: 34.818640015765226,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "32",
    name: "חוף ארגמן",
    lat: 32.917420955716494,
    lon: 35.07926528824393,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "33",
    name: "חוף סירונית",
    lat: 32.32644673808429,
    lon: 34.846189936688205,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "34",
    name: "חוף קריית צ'אנז",
    lat: 32.345112901568285,
    lon: 34.85259599852231,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "35",
    name: "חוף בית ינאי",
    lat: 32.3871679436298,
    lon: 34.8631663363316,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "36",
    name: "חוף אולגה",
    lat: 32.439431371264604,
    lon: 34.877016583962885,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "37",
    name: "חוף שדות ים",
    lat: 32.49104860048372,
    lon: 34.88828793445613,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "38",
    name: "חוף קיסריה",
    lat: 32.514778665376596,
    lon: 34.896418298682704,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "39",
    name: "חוף ג'סר אל זרקא",
    lat: 32.537738063288636,
    lon: 34.90020041524439,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "40",
    name: "חוף מעגן מיכאל",
    lat: 32.55776703771391,
    lon: 34.90649914615672,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "41",
    name: "חוף נחשולים",
    lat: 32.62407242737741,
    lon: 34.91988960099105,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "42",
    name: "חוף הזולות נווה ים דרום",
    lat: 32.67189563057246,
    lon: 34.92867464939692,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "43",
    name: "חוף עתלית",
    lat: 32.70870501627558,
    lon: 34.94027001627236,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "44",
    name: "חוף הקדרים",
    lat: 32.78172547461959,
    lon: 34.95330871514891,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "46",
    name: "חוף קריית ים",
    lat: 32.8403950157552,
    lon: 35.05570539262171,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "47",
    name: "חוף שבי ציון",
    lat: 32.98388180535793,
    lon: 35.07908535211986,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "48",
    name: "חוף סוקולוב",
    lat: 33.005127824368046,
    lon: 35.08689783842537,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "49",
    name: "חוף אכזיב",
    lat: 33.04418009092704,
    lon: 35.10018769433351,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
  {
    _id: "50",
    name: "חוף בצת",
    lat: 33.08112266583728,
    lon: 35.10566660452207,
    reviews: [
      { review: "חוף שקט ופחות עמוס." },
      { review: "גלים מתאימים גם למתחילים." },
    ],
  },
];

export const setSpots = () => ({
  type: 'SET_SPOTS',
  payload: mockSpots
});

export const addReview = (spotId, review) => ({
  type: 'ADD_REVIEW',
  payload: { 
    spotId, 
    review: { review } 
  },
});
